export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11143.269cd07e.jpg";